import { Pipe, PipeTransform } from '@angular/core';
import { Nullable } from '@markant-platform/shared/util-helpers';

@Pipe({
  name: 'concat',
  standalone: true,
})
export class ConcatPipe implements PipeTransform {
  transform(value: Nullable<string>, concatChar: string, otherValue: string | undefined | null): string {
    if (!value) {
      return '';
    }

    if (otherValue && concatChar) {
      return `${value}${concatChar}${otherValue}`;
    }

    return value;
  }
}
